import { LuFileText } from 'react-icons/lu';
import Button from '../button/button';
import { useNavigate } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import './header.style.scss';
import React from 'react';
import CustomInput from '../CustomInput/CustomInput';

type IHeaderProps = {
  pageTitle: string;
  buttonText: string;
  para?: React.ReactNode;
  extraButton?: React.ReactNode;
  buttonIcon?: React.ReactNode;
  isHeader?: boolean;
  path?: string;
  isActive?: boolean;
  search?: string; // Search prop passed from the parent component
  searchPlaceholder?: string;
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void; // onSearchChange function passed from parent
  onClick?: any;
  // onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onSearchClick?: () => void;
  type?: 'primary' | 'secondary' | 'link';
  firstButton?: any;
  isVisiableFirstButton?: boolean;
  isLeft?: boolean;
  buttonStyle?: React.CSSProperties;
};

const Header = ({
  para = false,
  extraButton = false,
  pageTitle,
  buttonText,
  buttonIcon = <LuFileText />,
  isHeader = false,
  path,
  isActive = true,
  search = '', // Use the search prop here, with default empty string
  searchPlaceholder = 'Search',
  onSearchChange,
  onSearchClick,
  onClick = console.log(''),
  type = 'primary',
  firstButton,
  isVisiableFirstButton = false,
  isLeft = true,
  buttonStyle,
}: IHeaderProps) => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <div className="header">
      <div className="col">
        <h2 className="title">{pageTitle}</h2>
        {para && para}
      </div>
      {isVisiableFirstButton && (
        <Button
          text={firstButton.text}
          icon={firstButton.icon}
          disabled={firstButton.isActive === false}
          onClick={firstButton.onClick}
          type={firstButton.type || 'secondary'}
          style={buttonStyle}
        />
      )}

      {isHeader && (
        <div className="header_search">
          <CustomInput
            value={search}
            placeholder={searchPlaceholder}
            style={{
              height: 40,
              minWidth: 250,
            }}
            onChange={e => onSearchChange && onSearchChange(e)}
          />
          <Button
            text=""
            icon={<FiSearch />}
            style={{
              height: 38,
            }}
            onClick={() => onSearchClick && onSearchClick()}
          />
        </div>
      )}

      <div className="col button_container">
        <Button
          text={buttonText}
          icon={buttonIcon}
          disabled={!isActive}
          onClick={() => onClick()}
          type={type}
          isLeft={isLeft}
        />
        {extraButton && extraButton}
      </div>
    </div>
  );
};

export default Header;
